import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { Subject, takeUntil } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

interface FoodNode {
  name: string;
  children?: FoodNode[];
  navigate: string;
  expandable?: boolean;
}

const TREE_DATA: FoodNode[] = [
  {
    name: 'Company Profiling',
    children: [
      {
        name: 'Company details',
        navigate: '/cam/company-management/company-details',
      },
      // {
      //   name: 'Division details',
      //   navigate: '/cam/company-management/division-details',
      // },
      {
        name: 'Office location information',
        navigate: '/cam/company-management/branch-information',
      },
      {
        name: 'Cost center overview',
        navigate: '/cam/company-management/cost-center-overview',
      },
      {
        name: 'Project details',
        navigate: '/cam/company-management/project-details',
      },
      {
        name: 'Corporate cards',
        navigate: '/cam/company-management/corporate-cards',
      },
      {
        name: 'Business unit overview',
        navigate: '/cam/company-management/business-unit-overview',
      },
    ],
    navigate: '/cam/company-management',
    expandable: true,
  },
  {
    name: 'Traveler Profiling',
    children: [
      { name: 'Department', navigate: '/cam/traveler-profile/department' },
      { name: 'Designation', navigate: '/cam/traveler-profile/designation' },
      {
        name: 'Employee grade',
        navigate: '/cam/traveler-profile/employeegrade',
      },
      {
        name: 'Travel category',
        navigate: '/cam/traveler-profile/travel-category',
      },
      // {
      //   name: 'Pre defined reasons',
      //   navigate: '/cam/traveler-profile/pre-defined-reasons',
      // },
    ],
    navigate: '/cam/traveler-profile',
    expandable: false,
  },
  {
    name: 'Other misc. functionality',
    children: [
      {
        name: 'Company settings',
        navigate: '/cam/other-misc-func/company-setting',
      },
      // {
      //   name: 'Flight promo code management',
      //   navigate: '/cam/other-misc-func/flight-promo-code-management',
      // },
      // { name: 'FAQs settings', navigate: '/not-made-yet' },
      // {
      //   name: 'Multi traveler management',
      //   navigate: '/cam/other-misc-func/multi-travel-management',
      // },
      // { name: 'Booking queue management', navigate: '/not-made-yet' },
      // { name: 'Data capture management', navigate: '/not-made-yet' },
      {
        name: 'Enable company login',
        navigate: '/cam/other-misc-func/enable-company-login',
      },
      {
        name: 'Change email domain',
        navigate: '/cam/other-misc-func/change-email-domain',
      },
    ],
    navigate: '',
    expandable: false,
  },
];
@Component({
    selector: 'app-menu-nav-expanded',
    templateUrl: './menu-nav-expanded.component.html',
    styleUrls: ['./menu-nav-expanded.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgFor, MatIconButton, MatIcon, NgIf, RouterLinkActive, RouterLink]
})
export class MenuNavExpandedComponent {
  dataSource: FoodNode[];
  private readonly destroy$ = new Subject<void>();
  content: any;
  constructor(
    private readonly router: Router,
    private readonly _CompanyManagementService: CompanyManagementService,
    private readonly contentService: CompanyManagementContentService,
  ) {
    this.contentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.content = res;
        this.dynamicMenu();
      });
    this.dataSource = TREE_DATA;
    const currentUrl = this.router.url;
    this.dataSource.forEach((node) => {
      const isActive = node.children?.some(
        (child) => child.navigate === currentUrl
      );
      node.expandable = !!isActive;
    });
  }

  companyManagement(clickedNode: any) {
    console.log("clickedNode", clickedNode)
    this.dataSource.forEach(node => {
      if (node === clickedNode) {
        node.expandable = !node.expandable;
      } else {
        node.expandable = false;
      }
    });

    this._CompanyManagementService.company_management_MenuClick();
  }


  onChildClick(event: Event, child: any) {
    event.stopPropagation(); // 👈 prevents collapsing
    this._CompanyManagementService.company_menu_click(child.name);
  }
  dynamicMenu() {
    // console.log(this.dataSource[0].children)
    this.dataSource[0].children?.forEach((value, index) => {
      switch (index) {
        case 0:
          value.name = this.content?.['b2b.managecompany.cdcompanydetails'];
          break;
        case 1:
          value.name = this.content?.['b2b.managecompany.officelocationinformation'];
          break;
        case 2:
          value.name = this.content?.['b2b.managecompany.bicostcenteroverview'];
          break;
        case 3:
          value.name = this.content?.['b2b.managecompany.pdprojectdetails'];
          break;
        case 4:
          value.name = this.content?.['b2b.managecompany.cccorporatecards'];
          break;
        case 5:
          value.name = this.content?.['b2b.managecompany.buotitle'];
          break;
      }
    });
    this.dataSource[1].children?.forEach((value, index) => {
      switch (index) {
        case 0:
          value.name =
            this.content?.['b2b.managecompany.department'];
          break;
        case 1:
          value.name = this.content?.['b2b.managecompany.ccdesignation'];
          break;
        case 2:
          value.name = this.content?.['b2b.managecompany.ccemployeegrade'];
          break;
        case 3:
          value.name = this.content?.['b2b.managecompany.tptravelcategory'];
          break;
        case 4:
          value.name = this.content?.['b2b.managecompany.tppredefinereasons'];
          break;
      }
    });
    this.dataSource[2].children?.forEach((value, index) => {
      switch (index) {
        case 0:
          value.name =
            this.content?.['b2b.managecompany.omfcompanysettings'];
          break;
        case 1:
          this.content?.['b2b.managecompany.omfenablecompanylogin'];
          // value.name = 'Flight promo code management';
          break;
        case 2:
          value.name =
            this.content?.['b2b.managecompany.omfchangeemaildomain'];
          // value.name = 'FAQs settings';
          break;
        // case 3:
        //   value.name =
        //     this.content?.['b2b.managecompany.omfmultitrevelerheading'];
        //   break;
        // case 4:
        //   value.name =
        //     this.content?.['b2b.managecompany.omfbookingqueuemanage'];
        //   break;
        // case 5:
        //   value.name =
        //     'Data capture management';
        //   break;
        // case 6:
        //   value.name =
        //     this.content?.['b2b.managecompany.omfenablecompanylogin'];
        //   break;
        // case 7:
        //   value.name =
        //     this.content?.['b2b.managecompany.omfchangeemaildomain'];
        //   break;
      }
    });
  }
}
